module.exports = __webpack_public_path__ + "img/pt.a36b3d87.svg";